import { makeUIHeading1, makeUIHeading2, makeUIHeading3, makeUIHeading4, makeUIHeading5, makeUIHeading6 } from '../../makeUIHeading';
var args = [{
  display: 'inline'
}, 'UIInlineHeading'];
export var UIInlineHeading1 = makeUIHeading1.apply(void 0, args);
export var UIInlineHeading2 = makeUIHeading2.apply(void 0, args);
export var UIInlineHeading3 = makeUIHeading3.apply(void 0, args);
export var UIInlineHeading4 = makeUIHeading4.apply(void 0, args);
export var UIInlineHeading5 = makeUIHeading5.apply(void 0, args);
export var UIInlineHeading6 = makeUIHeading6.apply(void 0, args);